import React, { useEffect } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import ListManagerPage from "./components/ListManagerPage";
import ItemManagerPage from "./components/ItemManagerPage";
import CustomerManagerPage from "./components/CustomerManagerPage";
import LoginPage from "./components/LoginPage";
import MyFavoritesPage from "./components/MyFavoritesPage";
import SignUpPage from "./components/SignUpPage";
import MyLockedPage from "./components/MyLockedPage";
import CampaignCatalogPage from "./components/CampaignCatalogPage";
import BigQuestionPage from "./components/BigQuestionPage";
import RequireAuth from "./components/RequireAuth";
import TermsPage from './components/TermsPage';
import PrivacyPage from './components/PrivacyPage';
import ContactPage from './components/ContactPage';
import Footer from './components/footer';
import UploadCampaignDataPage from "./components/UploadCampaignDataPage";
import BigQuestionHistoryPage from "./components/BigQuestionHistoryPage";
import FavoritesHistoryPage from "./components/FavoritesHistoryPage";
import MyOrganizerQuickAddPage from "./components/MyOrganizerQuickAddPage";
import MyOrganizerSetupPage from "./components/MyOrganizerSetupPage";



import { jwtDecode } from "jwt-decode";
import axios from "axios";

const App = () => {
  // ============================
  // ⏸ Polling logic temporarily disabled
  // ============================
  // useEffect(() => {
  //   const ENABLE_POLLING = false;
  //   if (!ENABLE_POLLING) return;

  //   const initializePolling = async () => {
  //     const idToken = localStorage.getItem("idToken");
  //     if (!idToken) return;

  //     const userId = jwtDecode(idToken).sub;

  //     try {
  //       const res = await axios.get("https://gwbtdh9454.execute-api.us-east-1.amazonaws.com/prod/campaign", {
  //         params: { operation: "fetch_customer", userid: userId },
  //         headers: { Authorization: `Bearer ${idToken}` },
  //       });

  //       const customer = res.data?.customer;
  //       if (!customer?.pollingNotificationsForFavorites) {
  //         console.log("🔕 Notifications disabled for this user.");
  //         return;
  //       }

  //       localStorage.setItem("pollingEnabled", "true");

  //       const pollNotifications = async () => {
  //         try {
  //           const payload = {
  //             operation: "get_unread_notifications",
  //             userid: userId,
  //           };

  //           const response = await axios.post(
  //             "https://gwbtdh9454.execute-api.us-east-1.amazonaws.com/prod/campaign",
  //             payload,
  //             {
  //               headers: { Authorization: `Bearer ${idToken}` },
  //             }
  //           );

  //           const notifications = Array.isArray(response.data) ? response.data : [];
  //           notifications.forEach((n) => {
  //             alert(`${n.title}\n\n${n.body}`);
  //           });
  //         } catch (err) {
  //           console.error("Polling error:", err);
  //         }
  //       };

  //       pollNotifications(); // Run once immediately
  //       const intervalId = setInterval(pollNotifications, 60000);
  //       return () => clearInterval(intervalId);
  //     } catch (err) {
  //       console.error("Failed to initialize notification polling:", err);
  //     }
  //   };

  //   // Delayed start to avoid interfering with initial render
  //   setTimeout(initializePolling, 100);
  // }, []);

  return (
    <Router>
      <Navbar />
      <Routes>
        {/* Public Routes */}
        <Route
            path="/"
            element={
              <RequireAuth>
                <Navigate to="/list-manager" replace />
              </RequireAuth>
            }
          />

          <Route path="/login" element={<LoginPage />} />

        
        <Route path="/signup" element={<SignUpPage />} />

        {/* Protected Routes */}
        {/* <Route path="/campaign-manager" element={<RequireAuth><ListManagerPage /></RequireAuth>} /> */}
        <Route path="/list-manager" element={<RequireAuth><ListManagerPage /></RequireAuth>} />
        <Route path="/item-manager" element={<RequireAuth><ItemManagerPage /></RequireAuth>} />
        <Route path="/item-manager/:campaignName" element={<RequireAuth><ItemManagerPage /></RequireAuth>} />
        <Route path="/customer-manager" element={<RequireAuth><CustomerManagerPage /></RequireAuth>} />

        <Route path="/myfavorites" element={<RequireAuth><MyFavoritesPage /></RequireAuth>} />
        <Route path="/locked-page" element={<RequireAuth><MyLockedPage /></RequireAuth>} />
        <Route path="/campaign-catalog" element={<RequireAuth><CampaignCatalogPage /></RequireAuth>} />



        <Route
          path="/q"
          element={
            <RequireAuth>
              <MyOrganizerQuickAddPage />
            </RequireAuth>
          }
        />

        <Route
          path="/q/:captureToken"
          element={<MyOrganizerQuickAddPage />}
        />



        <Route
          path="/myorganizer-setup"
          element={
            <RequireAuth>
              <MyOrganizerSetupPage />
            </RequireAuth>
          }
        />




        <Route path="/big-question" element={<RequireAuth><BigQuestionPage /></RequireAuth>} />
        <Route path="/big-question/:campaignName" element={<RequireAuth><BigQuestionPage /></RequireAuth>} />

        <Route path="/upload-campaign-data" element={<RequireAuth><UploadCampaignDataPage /></RequireAuth>} />

        <Route path="/big-question-history" element={<RequireAuth><BigQuestionHistoryPage /></RequireAuth>} />
        <Route path="/favorites-history" element={<RequireAuth><FavoritesHistoryPage /></RequireAuth>} />

        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>


    <Footer /> {/* 👈 Add this here */}



    </Router>
  );
};

export default App;
